import { C } from '../theme'
import { Reveal, RevealStagger } from './Reveal'
import { useContent } from '../content/ContentContext'
import { mediaAlt, mediaUrl } from '../content/derive'

export function Events() {
  const { home, ministries } = useContent()
  const intro = home.eventsIntro ?? {}

  return (
    <section id="eventos" aria-label={intro.title ?? 'Eventos'} className="sec" style={{ padding: '96px 40px 104px', background: C.sand2 }}>
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <Reveal style={{ textAlign: 'center', maxWidth: 680, margin: '0 auto 56px' }}>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: C.red, marginBottom: 18 }}>
            {intro.eyebrow}
          </div>
          <h2 className="section-title" style={{ fontFamily: "'Spectral',serif", fontWeight: 400, fontSize: 46, lineHeight: 1.08, margin: '0 0 8px', color: C.ink, letterSpacing: '-.01em' }}>
            {intro.title}
          </h2>
          <p style={{ fontFamily: "'Spectral',serif", fontStyle: 'italic', fontSize: 17, color: C.muted, margin: 0 }}>
            {intro.subtitle}
          </p>
        </Reveal>
        {ministries.length > 0 && (
          <RevealStagger className="stack grid-3" style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(ministries.length, 3)},1fr)`, gap: 28 }}>
            {ministries.map((m) => {
              const imageUrl = mediaUrl(m.image)
              return (
                <article key={m.id} className="evcard" style={{ background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 14px 38px rgba(21,35,63,.09)' }}>
                  {imageUrl && (
                    <div style={{ height: 300, overflow: 'hidden', borderRadius: '170px 170px 0 0' }}>
                      <img src={imageUrl} alt={mediaAlt(m.image, m.alt)} className="evimg" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                    </div>
                  )}
                  <div style={{ padding: '26px 26px 30px' }}>
                    <h3 style={{ fontFamily: "'Spectral',serif", fontWeight: 500, fontSize: 25, margin: '0 0 4px', color: C.ink }}>{m.title}</h3>
                    <div style={{ fontSize: 13, fontStyle: 'italic', color: C.muted, marginBottom: 14 }}>{m.en}</div>
                    <p style={{ fontSize: 14.5, lineHeight: 1.6, color: C.body, margin: 0 }}>{m.description}</p>
                  </div>
                </article>
              )
            })}
          </RevealStagger>
        )}
        {intro.ctaLabel && (
          <div style={{ textAlign: 'center', marginTop: 48 }}>
            <a className="btn" href="#contacto" style={{ background: C.red, color: '#fff', fontWeight: 700, fontSize: 15, padding: '16px 34px', borderRadius: 3, textDecoration: 'none', boxShadow: '0 8px 24px rgba(193,39,45,.3)' }}>
              {intro.ctaLabel}
            </a>
          </div>
        )}
      </div>
    </section>
  )
}
